import React from 'react';
import { IntroOutroContextType } from './types';

export const IntroOutroContext = React.createContext<
  IntroOutroContextType | undefined
>(undefined);
